import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;

    const hash = location.hash || window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { navigate("/login"); return; }
    const sid = m[1];
    (async () => {
      try {
        const { data } = await api.post("/auth/google-session", null, { headers: { "X-Session-ID": sid } });
        localStorage.setItem("acrepulse_token", data.token);
        setUser(data.user);
        window.history.replaceState({}, document.title, "/dashboard");
        toast.success(`Welcome, ${data.user.name}`);
        navigate(data.user.role === "admin" ? "/admin" : "/map", { state: { user: data.user } });
      } catch {
        toast.error("Google sign-in failed");
        navigate("/login");
      }
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-screen grid place-items-center bg-[#0F172A] text-slate-400 text-sm">
      Establishing your secure session…
    </div>
  );
}
